/* ==========================================================================
   HOUND SITE HEADER
   ==========================================================================
   Keeps the cart badge honest, and opens the cart drawer from the bar's pill.

   The header is server rendered, so without this it shows whatever the count
   was when the page loaded: add something to the cart and the bar still reads
   empty until a refresh. Three of the site's headers had that bug; the PDP's
   version was the only one that did not, so this is that implementation
   promoted into the shared component.

   Belt and braces on purpose: subscribe to the theme's own cart bus, fall back
   to reading /cart.js when an event arrives without a payload, and re-read once
   after any add-to-cart click in case the bus is not wired on that surface.
   ========================================================================== */
(function () {
  'use strict';

  var el = document.querySelector('[data-hound-cart-count]');
  if (!el) return;

  function paint(n) {
    if (typeof n !== 'number') return;
    if (String(n) !== el.textContent) el.textContent = n;
    el.hidden = n === 0;
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.item_count); })
      .catch(function () {});
  }

  if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
      var c = payload && payload.cartData;
      if (c && typeof c.item_count === 'number') paint(c.item_count);
      else refresh();
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], .product-form__submit, [data-cart-remove], .cart-remove-button')) {
      setTimeout(refresh, 1200);
    }
  });

  /* The bar's cart pill opens the theme's cart drawer when the page has one
     (sections/cart-drawer, in the overlay group), like the main theme's own
     cart icon; without one it stays a plain link to /cart. Not on the cart
     page itself (it is the current page there). No aria-controls on purpose:
     the drawer would bind it as a second toggle and close what this opens. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.hm-bar-cart');
    if (!a || a.getAttribute('aria-current') === 'page') return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var d = document.getElementById('CartDrawer');
    if (!d || typeof d.show !== 'function') return;
    e.preventDefault();
    d.show(a);
  });

  /* Back from /cart restores this page from the bfcache with its old count. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* The theme header this replaces is hidden by CSS, but section groups can
     render after us on some templates. */
  function hideStock() {
    ['header.header', '#shopify-section-group-header-group', '#shopify-section-announcement-bar'].forEach(function (s) {
      document.querySelectorAll(s).forEach(function (n) {
        n.style.setProperty('display', 'none', 'important');
      });
    });
  }
  hideStock();
  setTimeout(hideStock, 60);
  setTimeout(hideStock, 220);
})();
